/* src/app/core/modules/shared/components/spinner-circle/spinner-circle.component.scss */
.spinner-circle {
  display: inline-block;
  position: relative;
  --spinner-color: var(--ion-color-primary-rgb);
}
.spinner-circle--accent {
  --spinner-color: var(--ion-color-accent-rgb);
}
.spinner-circle--success {
  --spinner-color: var(--ion-color-success-rgb);
}
.spinner-circle--warning {
  --spinner-color: var(--ion-color-warning-rgb);
}
.spinner-circle--danger {
  --spinner-color: var(--ion-color-danger-rgb);
}
.spinner-circle--light {
  --spinner-color: var(--ion-color-light-rgb);
}
.spinner-circle ion-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-animation: intermittentLoad 1.1s infinite linear;
  animation: intermittentLoad 1.1s infinite linear;
  color: rgba(var(--spinner-color), 1);
}
.spinner-circle .loader,
.spinner-circle .loader:after {
  border-radius: 50%;
  width: 100px;
  height: 100px;
}
.spinner-circle .loader {
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 6px solid rgba(var(--spinner-color), 0.2);
  border-right: 6px solid rgba(var(--spinner-color), 0.2);
  border-bottom: 6px solid rgba(var(--spinner-color), 0.2);
  border-left: 6px solid rgba(var(--spinner-color), 1);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: rotateLoad 1.1s infinite linear;
  animation: rotateLoad 1.1s infinite linear;
}
.spinner-circle--static .loader {
  border-left: 6px solid rgba(var(--spinner-color), 0.2);
  -webkit-animation: none;
  animation: none;
}
.spinner-circle--static ion-icon {
  -webkit-animation: none;
  animation: none;
}
@-webkit-keyframes rotateLoad {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotateLoad {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes intermittentLoad {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes intermittentLoad {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
/*# sourceMappingURL=/avvera/dev/spinner-circle.component.css.map */
